module.exports = new __parcel__URL__("lwn-en.02c82178.svg").toString();